"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _WithdrawWorkflowsComponent = _interopRequireDefault(require("./WithdrawWorkflowsComponent"));
var _config = _interopRequireDefault(require("../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    templateType: _config["default"].Withdraw.Template || state.withdraw.templateType,
    loading: state.withdraw.isLoading
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_WithdrawWorkflowsComponent["default"]);